// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1Id1k","header":"PatientQuestionnaire_header__3UA_a","info":"PatientQuestionnaire_info__2M4vp"};